import { useHistory, useLocation } from "react-router";
import IconBar from "../../Partials/IconBar";
import TabPages from "../../Partials/TabPages";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { getPublicTestDetails, getPublicTests } from "../../../api/test";
import TestListAssignedContent from "../../Tests/TestListAssignedContent";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {useAuth} from "../../../context/AuthContext";

const TestDashboard = () => {
  const history = useHistory();

    const { user } = useAuth();
    console.log("this is the user", user);
  if (user === undefined) history.push("/login");

  const [tests, setTests] = useState([]);
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("SearchTerm")
  );
  const [subject, setSubject] = useState(localStorage.getItem("Subject") || "");
  const [grade, setGrade] = useState(localStorage.getItem("Grade"));
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState(false);

  const onTestClickHandler = async (testID) => {
    const testDetails = await getPublicTestDetails(
      user.token,
      testID.toString()
    );

    history.push("/teststart", { user: user, test: testDetails.message });
  };

  const activateReferences = () => {
    history.push("/resourcedashboard", { user: user });
  };

  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
    localStorage.setItem("SearchTerm", e.target.value);
    setTests([]);
  };

  const gradeHandler = (e) => {
    setGrade(e.target.value);
    localStorage.setItem("Grade", e.target.value);
    setTests([]);
  };

  const subjectHandler = (e) => {
    setSubject(e.target.value);
    localStorage.setItem("Subject", e.target.value);
    setTests([]);
  };

  const getTests = async () => {
    setIsLoading(true);
    setErr(false);
    try {
      const fetchTestsResponse = await getPublicTests(
        user.token,
        subject,
        grade,
        searchTerm
      );
      setTests(Array.isArray(fetchTestsResponse.message) ? fetchTestsResponse.message : []);
    } catch (error) {
      console.error(error);
      setErr(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTests();
  }, [subject, grade, searchTerm]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const tabHeadings = ["TESTS", "RESOURCES"];
  const tabFunctions = [() => {}, activateReferences];

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: windowWidth >= 800 ? "50%" : "90%",
        }}
      >
        <div style={{ padding: "10px 0" }}>
          {/*tab container*/}
          <div
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "#00112e",
              zIndex: "1400",
            }}
          >
            {/*icon bar*/}
            <div>
              <IconBar location={"dashboard"} user={user} />
            </div>
            {/*tab headings*/}
            <div
              style={{
                width: "100%",
              }}
            >
              <TabPages
                tabHeadings={tabHeadings}
                tabFunctions={tabFunctions}
                tabActive={0}
              />
            </div>
          </div>
          <div style={{ backgroundColor: "#DFDFDF" }}></div>
          <div>
            <div
              style={{
                padding: "0px",
                height: "100%",
                width: "100%",
                zIndex: 0,
              }}
            >
              <TestListAssignedContent user={user} />

              <div
                style={{
                  backgroundColor: "#00122d",
                  minHeight: "300px",
                }}
              >
                <div
                  style={{
                    maxWidth: "100%",
                    backgroundColor: "#212a41",
                    padding: "15px",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#212a41",
                      borderRadius: "5px",
                      marginBottom: "15px",
                      width: windowWidth >= 800 ? "100%" : "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "bold",
                        color: "#fbcd02",
                        padding: "5px",
                        textAlign: "left",
                        marginBottom: "5px",
                        fontSize: "1.1rem",
                      }}
                    >
                      Search Tests
                    </Typography>

                    <Box
                      component="form"
                      sx={{
                        "& > :not(style)": {
                          width: "100%",
                          marginBottom: "10px",
                        },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <TextField
                        id="outlined-basic"
                        label="Search"
                        variant="outlined"
                        value={searchTerm}
                        onChange={searchHandler}
                        fullWidth
                        sx={{
                          backgroundColor: "#00122d",
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#00122d",
                            },
                            "&:hover fieldset": {
                              borderColor: "#FBCD02",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#FBCD02",
                            },
                          },
                        }}
                        InputLabelProps={{
                          style: { color: "#FBCD02" },
                        }}
                        inputProps={{
                          style: { color: "white" },
                        }}
                      />

                      {/* Grade Dropdown */}
                      <Box sx={{ minWidth: 120, marginTop: "10px" }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="grade-select-label"
                            sx={{
                              color: "#FBCD02",
                              "&.Mui-focused": {
                                color: "#FBCD02",
                              },
                            }}
                          >
                            Grade
                          </InputLabel>
                          <Select
                            labelId="grade-select-label"
                            id="grade-select"
                            value={grade}
                            label="Grade"
                            onChange={gradeHandler}
                            sx={{
                              backgroundColor: "#00122d",
                              color: "white",
                              "& .MuiSvgIcon-root": {
                                color: "white",
                              },
                              textAlign: "left",
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#FBCD02",
                                },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#00122d",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FBCD02",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  textAlign: "left",
                                  backgroundColor: "#00122d",
                                  color: "white",
                                },
                              },
                              MenuListProps: {
                                sx: {
                                  "& .Mui-selected": {
                                    backgroundColor: "#FBCD02 !important",
                                    color: "#00122d",
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="Any">
                              Any
                            </MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={11}>11</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                            <MenuItem value={"Teacher"}>Teacher</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>

                      {/* Subject Dropdown */}
                      <Box sx={{ minWidth: 120, marginTop: "20px" }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="subject-select-label"
                            sx={{
                              color: "#FBCD02",
                              "&.Mui-focused": {
                                color: "#FBCD02",
                              },
                            }}
                          >
                            Subject
                          </InputLabel>
                          <Select
                            labelId="subject-select-label"
                            id="subject-select"
                            value={subject}
                            label="Subject"
                            onChange={subjectHandler}
                            sx={{
                              backgroundColor: "#00122d",
                              color: "white",
                              "& .MuiSvgIcon-root": {
                                color: "white",
                              },
                              textAlign: "left",
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#FBCD02",
                                },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#00122d",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FBCD02",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  textAlign: "left",
                                  backgroundColor: "#00122d",
                                  color: "white",
                                },
                              },
                              MenuListProps: {
                                sx: {
                                  "& .Mui-selected": {
                                    backgroundColor: "#FBCD02 !important",
                                    color: "#00122d",
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value=""> All Subjects</MenuItem>
                            <MenuItem value={"Physical Sciences"}>
                              Physical Sciences
                            </MenuItem>
                            <MenuItem value={"Mathematics"}>
                              Mathematics
                            </MenuItem>
                            <MenuItem value={"Maths Lit"}>Maths Lit</MenuItem>
                            <MenuItem value={"Life Sciences"}>
                              Life Sciences
                            </MenuItem>
                            <MenuItem value={"Economic Sciences"}>
                              Economic Sciences
                            </MenuItem>
                            <MenuItem value={"Life Orientation"}>
                              Life Orientation
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>

                    <div
                      style={{
                        height: "100%",
                        color: "white",
                        marginTop: "20px",
                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          color: "#fbcd02",
                          padding: "5px",
                          textAlign: "left",
                          marginBottom: "5px",
                          fontSize: "1.1rem",
                        }}
                      >
                        Open Tests
                      </Typography>
                      <hr
                        style={{
                          marginBottom: "20px",
                          borderColor: "#FBCD02",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          width: "100%",
                        }}
                      />
                      {isLoading ? (
                        <CircularProgress sx={{ color: "#FBCD02" }} />
                      ) : tests.length === 0 ? (
                        err ? (
                          <div style={{ color: "white" }}>
                            Error Loading Tests
                          </div>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                              color: "white",
                              "@keyframes fadeIn": {
                                from: { opacity: 0 },
                                to: { opacity: 1 },
                              },
                              animation: "fadeIn 2s ease-in-out",
                            }}
                          >
                            <ErrorOutlineIcon
                              sx={{
                                fontSize: 40,
                                marginBottom: 2,
                                animation: "fadeIn 2s ease-in-out",
                              }}
                            />
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: "bold",
                                animation: "fadeIn 2s ease-in-out",
                              }}
                            >
                              No Open Tests Found
                            </Typography>
                          </Box>
                        )
                      ) : (
                        <>
                          {Array.isArray(tests) && tests.map((item, i) => (
                            <div
                              key={i}
                              className={"ReferenceCard"}
                              style={{
                                borderWidth: "1px",
                                borderStyle: "solid",
                                borderColor: "#00112e",
                                backgroundColor: "white",
                                marginBottom: "10px",
                                cursor: "pointer",
                                width: "100%",
                              }}
                              onClick={() => onTestClickHandler(item.id)}
                            >
                              {item.name}
                            </div>
                          ))}
                          <div
                            style={{
                              marginTop: "20px",
                              color: "white",
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                          >
                            No More Open Tests Found
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestDashboard;
